module.exports = __webpack_public_path__ + "static/other/gameCareerFair.019fced6.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameCareerFair.json
// module id = 2342
// module chunks = 0